import Vue from 'vue'
import Empty from './empty/empty.vue'
// import CheckboxGroup from './checkbox/checkbox-group'
// import CheckboxButton from './checkbox/checkbox-button'
// import RadioGroup from './radio/radio-group'
// import RadioButton from './radio/radio-button'
import KVPanel from './k-v-panel/k-v-panel'
import Backtop from './backtop/backtop'
import QDialog from './q-dialog/q-dialog'
import QSelect from './q-select/q-select'
import QTable from './q-table/q-table'
import QDatePicker from './date-picker/date-picker'
import FloatButton from './float-button/float-button'

const components = [
  Empty, KVPanel, Backtop, QDialog, QSelect, QTable, QDatePicker, FloatButton
];
components.forEach(component => {
  if (component.name) {
    Vue.component(component.name, component);
  }
});